var map = {
	"./adventure.svg": "8c7a",
	"./all.svg": "bfcc",
	"./biography.svg": "8704",
	"./comedy.svg": "0233",
	"./default.svg": "9308",
	"./drama.svg": "9bcb",
	"./fantasy.svg": "b067",
	"./horror.svg": "3a0a",
	"./how-to.svg": "8698",
	"./mystery.svg": "4385",
	"./orange/adventure.svg": "2dcc",
	"./orange/all.svg": "d9e7",
	"./orange/biography.svg": "616a",
	"./orange/comedy.svg": "2ab8",
	"./orange/default.svg": "a34c",
	"./orange/drama.svg": "e9ae",
	"./orange/fantasy.svg": "c389",
	"./orange/horror.svg": "9ded",
	"./orange/how-to.svg": "d25d",
	"./orange/mystery.svg": "438e",
	"./orange/romance.svg": "a142",
	"./orange/science-fiction.svg": "52e5",
	"./orange/self-help.svg": "aade",
	"./orange/thriller.svg": "c5dd",
	"./romance.svg": "7370",
	"./science-fiction.svg": "e5c1",
	"./self-help.svg": "d2e7",
	"./thriller.svg": "5e1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a77";